import React, { Component } from 'react'
import { MenuItem } from 'components/navigation'
import ForumIcon from '@mui/icons-material/Forum';

export default class ComunicacionesMenu extends Component {

    /**
     * ComponentDidMount
     * 
     * Inicializamos los componentes necesarios del tema
     */
    componentDidMount() {
        window.KTMenu?.createInstances()
        window.KTToggle?.createInstances()
    }


    /**
     * Render
     * 
     * @returns {Component}
     */
    render() {
        return (
            <div className="menu menu-column menu-rounded menu-sub-indention px-3" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">

                <div className="menu-item pt-5">
                    <div className="menu-content">
                        <span className="menu-heading fw-bold text-uppercase fs-7">Comunicaciones</span>
                    </div>
                </div>

                {/* <MenuItem title="Comunicaciones Alumnos" to="./comunicaciones" icon={<ForumIcon />} /> */}
            </div>
        )
    }
}
